import { jsx } from 'react/jsx-runtime';
import React__default from 'react';
import { UserStatus } from '@mirohq-internal/website-utils';
import { Drawer } from '../drawer/drawer.esm.js';
import { DrawerMenu } from './components/drawer-menu.esm.js';
import { getMenuNode } from './helpers/get-menu-node.esm.js';

/**
 * Miro Header is our main header for the site.
 * It contains the main navigation and the meta menu and a drawer
 * menu for breakpoints below xl.
 *
 * @figma - https://www.figma.com/file/A90pL0uhBHbmuaP5By4DW3/Website-VIS2.0---Design-specifications?node-id=1%3A12476&mode=dev
 */ const MiroDrawer = ({ isOpen = false, menu, metaMenuLinks, setIsOpen, userStatus = UserStatus.loggedIn })=>{
    /**
     * The currentMenuPath state is used to keep track of the menu that the
     * user has navigated to in the drawer menu. This is an array of indexes
     * that represent the path to the current menu in the menu's tree data structure.
     */ const [currentMenuPath, setCurrentMenuPath] = React__default.useState([]);
    const menuNode = getMenuNode(menu, currentMenuPath);
    const handleBack = ()=>{
        /**
         * Removing the last index from the currentMenuPath array
         * to go back to the previous menu
         */ setCurrentMenuPath(currentMenuPath.slice(0, -1));
    };
    const handleClose = ()=>{
        /**
         * Resetting all states when the drawer is closed
         */ setCurrentMenuPath([]);
        setIsOpen(false);
    };
    return jsx(Drawer, {
        backdropClassName: "d-xl-none",
        className: "d-xl-none",
        handleClose: handleClose,
        handleBack: handleBack,
        currentMenuPath: currentMenuPath,
        show: isOpen,
        title: menuNode?.label || 'Menu',
        children: jsx(DrawerMenu, {
            userStatus: userStatus,
            menu: menuNode,
            currentMenuPath: currentMenuPath,
            setCurrentMenuPath: setCurrentMenuPath,
            ...metaMenuLinks
        })
    });
};

export { MiroDrawer };
